// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__x6RMc","fileBtn":"File_fileBtn__L90Yc","closeBtn":"File_closeBtn__2vhJI","fileSelected":"File_fileSelected__2xwW0","disabled":"File_disabled__4XfdA"};